import type { NavTourStep } from './navTourSteps';

/** Spotlight CSS selector for a nav-tour step (pure; no React). */
export function anchorSelectorForStep(step: NavTourStep): string {
  if (step.anchor === 'settings-marketplace') {
    return '[data-testid="settings-marketplace-enable"], [data-testid="settings-marketplace-enabled"], #marketplace-host-heading';
  }
  return `[data-nav-tour-id="${step.id}"]`;
}

export type NavTourAnchorRect = { top: number; left: number; width: number; height: number };

/**
 * Keep the coach bubble inside the viewport so Next/Skip stay clickable
 * (settings marketplace anchors can sit below the fold).
 */
export function clampNavTourBubblePosition(
  anchor: NavTourAnchorRect,
  viewport: { width: number; height: number },
  bubbleSize: { width: number; height: number } = { width: 300, height: 240 },
): { top: number; left: number } {
  const margin = 12;
  let left = anchor.left + anchor.width + 16;
  if (left + bubbleSize.width > viewport.width - margin) {
    left = Math.max(margin, anchor.left - bubbleSize.width - 16);
  }
  left = Math.min(Math.max(margin, left), Math.max(margin, viewport.width - bubbleSize.width - margin));

  let top = anchor.top + anchor.height / 2 - 40;
  top = Math.min(Math.max(margin, top), Math.max(margin, viewport.height - bubbleSize.height - margin));
  return { top, left };
}
